<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row>
                <Col span="24">
                    <FormItem prop="cancelRemark" label="取消原因">
                        <Input v-model="info.cancelRemark" type="textarea" />
                    </FormItem>
                </Col>
            </Row>

            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="nickName">
                        <Input v-model="user.nickName" disabled />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import config from '@/config'

import {
    repairAdd,
    repairCancel,
    repairReceive,
    repairView,
} from '@/api/repair'

export default {
    name: 'BillForm',

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: '', // 数据编号
                cancelRemark: '',
            },
        }
    },

    computed: {
        ruleValidate() {
            return {
                cancelRemark: [
                    {
                        required: true,
                        message: '原因必填',
                    },
                ],
            }
        },
        user() {
            return this.$store.state.user.info
        },
    },
    methods: {
        fetch() {
            return Promise.resolve()
        },
    },

    mounted() {
        var $info = this.$refs.info

        // 预加载
        this.$modal.beforeEnter((next) => {
            next()
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    const info = this.$refs.info.populateData()
                    info.id = this.id
                    // clog(info)
                    return repairCancel(info)
                    // return Promise.resolve()
                })
                .then((res) => {
                    this.$Message.success('取消成功')
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
